import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { NotificationResultAction } from "./notification-result.action";
import { NotificationResultService } from "./notification-result.service";

@Injectable()
export class NotificationResultEffect {
	setNotificationResult$ = createEffect(() =>
		this.actions$.pipe(
			ofType(NotificationResultAction.set),
			switchMap(({ model }) =>
				this.service.set(model).pipe(
					map(() => NotificationResultAction.setSuccess()),
					catchError((error: AppError) => of(NotificationResultAction.setFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private service: NotificationResultService
	) {}
}
